import React from 'react'
import gifweb4 from '../assets/imgs/webflowgif.gif'

export const GifwebFour = () => {
  return (
    <div>
        <img src={gifweb4} alt="gifweb" className="w-full h-full m-3 rounded-md" />
    </div>
  )
}